import Link from 'next/link';
import { useEffect } from 'react';

import { OFFERS } from '../../constants/routes';
import { getProductsCartInfo, viewItemList } from '../../utils/analytics';
import ProductListItem from '../ProductsMenu/ProductListItem';

import styles from './FavoriteProducts.module.scss';

export default function FavoriteProducts({ productsShowing, categoriesShowing, quantitiesOfProducts, loading }) {
  useEffect(() => {
    if (productsShowing.length > 0) {
      viewItemList(getProductsCartInfo(productsShowing.flat()), {
        item_list_id: 'Favorites',
        item_list_name: 'Αγαπημένα',
      });
    }
  }, [JSON.stringify(productsShowing)]);

  return (
    <section className={styles.section}>
      <h1 className={styles.header}>ΑΓΑΠΗΜΕΝΑ ΠΡΟΪΟΝΤΑ</h1>
      {productsShowing.length !== 0 && !loading && (
        <>
          <p className={styles.text}>
            Διάλεξε από τα αγαπημένα σου προϊόντα και τις έξυπνες προτάσεις μας από προϊόντα που ψωνίζεις συχνότερα!
          </p>
          <p className={styles.text}> Πρόσθεσέ τα στο καλάθι για ακόμα πιο εύκολες και γρήγορες αγορές!</p>

          <ul className={styles.listFavorites}>
            {categoriesShowing.map((c, index) => (
              <div key={c._id}>
                <div className={styles.listHeader}>
                  <h2 className={styles.listTitle}>{c.name}</h2>
                </div>
                <div className={styles.listContainer}>
                  {productsShowing[index]?.map(p => (
                    <ProductListItem
                      key={p._id}
                      _product={p}
                      productsQuantities={quantitiesOfProducts[p._id]}
                      disabled={!p.enabled || !p.available}
                      itemListId="Favorites"
                      itemListName="Αγαπημένα"
                    />
                  ))}
                </div>
              </div>
            ))}
          </ul>
        </>
      )}
      {productsShowing.length === 0 && !loading && (
        <div className={styles.emptyStateContainer}>
          <img className={styles.emptyStateIcon} src="/assets/global/favorite-cart.png" alt="cart with a heart" />
          <h3 className={styles.emptyStateHeader}>Η λίστα με τα αγαπημένα σου είναι κενή!</h3>
          <p className={styles.emptyStateText}>
            Πρόσθεσε στη λίστα τα αγαπημένα σου προϊόντα από τον κατάλογο και ξεκίνα τις αγορές σου, για να σου κάνουμε
            έξυπνες προτάσεις με βάση τα προϊόντα που ψωνίζεις συχνότερα!
          </p>
          <p className={styles.emptyStateText}>Έτσι οι αγορές σου γίνονται ακόμα πιο εύκολες και γρήγορες!</p>
          <div className={styles.linkContainer}>
            <Link href={OFFERS}>
              <a className={styles.emptyStateLink}>Δες τα προϊόντα</a>
            </Link>
          </div>
        </div>
      )}
    </section>
  );
}
